import React from 'react';
import { useTranslation } from 'react-i18next';
import completed from '../assets/images/completed.png';
import { Row, Container, Col } from 'reactstrap';
import NavbarComponent from '../Components/Header/Navbar';

const AssessmentFinished = () => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <NavbarComponent language={undefined} languagesList={undefined} changeLanguages={undefined} />
            <Container fluid={true}>
                <Row className="justify-content-center page-content">
                    <Col xl={6} className="text-center">
                        <div className="error-500 position-relative">
                            {/* <img src={completed} alt="" className="img-fluid error-500-img error-img" /> */}
                            <h4>
                                Thank you for submitting your assessment. A care coordinator will contact you shortly to follow up on the
                                next steps.
                            </h4>
                        </div>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    );
};

export default AssessmentFinished;
